module.exports = __webpack_public_path__ + "img/wallet_credit_card.c864427e.svg";